<div class="feed-content">
  <img class="tw-max-w-[500px] tw-block tw-m-auto" [src]="feed?.url" (click)="onLikeClick()" [width]="style.width" />
  <i class="cs-icon-favorite" *ngIf="playLikeAnimation"></i>
</div>